import { CardDefinition, ServiceType } from '@/types';
import Card from './Card';
import Loader from '@/components/Loader';

interface CardsProps {
  items: CardDefinition[]; // serviceType is added in CardDefinition by AllTextPage to handle multi services
  serviceType?: ServiceType | undefined; // serviceType passed directly by MediaSectionMultiFitnessYogaPilates
}

export default function Cards({ items, serviceType }: CardsProps) {
  return (
    <div className='mt-8 grid grid-cols-1 sm:grid-cols-3 sm:gap-0 gap-2'>
      {items.length === 0 && <Loader />}
      {items.map((item) => (
        <Card
          key={`${item.id}${item.serviceType}`}
          {...item}
          serviceType={serviceType ?? item.serviceType}
        />
      ))}
    </div>
  );
}
